import styled from "styled-components";

export const ButtonContainer = styled.button`
  border: ${({ theme }) => theme.button.border.base};
  text-transform: none;
  color: ${({ theme }) => theme.button.font.primary};
  font-weight: ${({ theme }) => theme.constants.FONT_WEIGHT_400};
  border-radius: ${({ theme }) => theme.button.radius};
  background: ${({ theme }) => theme.button.bg.primary};
  box-shadow: ${({ theme }) => theme.button.shadow};
  padding: ${({ theme }) => theme.button.padding.base};

  &.button-primary {
    display: flex;
    width: fit-content;
    padding: 10px 14px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 2px solid rgba(255, 255, 255, 0.12);
    background: #406ad0;
    font-family: "Geist", sans-serif;
    &:hover {
      background-color: rgb(0, 132, 237);
    }
    &:disabled {
      background: #6c98efff;
      cursor: not-allowed;
    }
  }
  &.button-secondary {
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    border: 1px solid rgb(213, 215, 218);
    background: rgb(255, 255, 255);
    padding: 8px 12px;
    color: rgba(10, 13, 18, 0.7);
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    box-shadow: none;
  }

  &.button-outlined {
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.button.bg.primary};
    color: ${({ theme }) => theme.button.bg.primary};
    &:hover {
      background-color: transparent;
    }
  }

  &.button-options {
    background-color: ${({ theme }) => theme.input.bg.quaternary};
    color: #717184;
    font-weight: 500;
    text-align: left;
    text-wrap: nowrap;

    &:hover {
      background-color: ${({ theme }) => theme.input.bg.quaternary};
    }

    &.selected {
      background-color: ${({ theme }) => theme.button.bg.primary};
      color: #fff;
    }
  }

  &.button-small {
    height: fit-content;
    width: fit-content;
    font-size: 14px;
    padding: ${({ theme }) => theme.button.padding.base};
  }
  &.button-medium {
    font-size: 13px;
    padding: ${({ theme }) => theme.button.padding.base};
  }
  &.button-large {
    font-size: 16px;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 767px) {
    &.button-options {
      text-wrap: wrap;
    }
  }
`;
